module.exports = __webpack_public_path__ + "vue-development.3r6Xx4Ph.svg";